import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import Navbar from './../Navbar/navbar.jsx';
import Navigation from './../Navigation/navigation.jsx';
import { isLogin } from './../../utils/authentication.js';
import { Form, Button, Table, ListGroup } from 'react-bootstrap';
import Loader from 'react-loader-spinner'
import _ from 'lodash'
import Moment from "moment";
import axios from 'axios';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import { BACKEND_URL_MAIN as BACKEND_URL } from '../../config.js';


class Notifications extends React.PureComponent {
  state = {
    isLoading: false,
    options: [],
    selectedUsers: [],
    text: "",
    isSaving: false,
    notificationsList: []
  };

  componentDidMount() {
    if(!isLogin()){
        this.props.history.push({
            pathname:"/login"
        });
    }

    this.getAllList()

  }

  getAllList = ()=> {
    axios.get(`${BACKEND_URL}/v1/explore/getAllNotification`, { headers: { token: localStorage.getItem("token") } }).then(response => {
      console.log(response.data);
      this.setState({notificationsList: response.data})
    })
    .catch((error) => {
      console.log('error 3 ' + error);
    });
  }

  handleDelete = (id)=> {
    let conf = confirm("Are you sure you want to delete?")
    if(conf) {
      axios.post(
        `${BACKEND_URL}/v1/explore/deleteNotification`, {
            id: id
        }, {
            headers: {
                token: localStorage.getItem("token")
            }
        }
      ).then((res) => {
        this.getAllList()
        this.setState({isSaving: false})

      }).catch((err) => {
        this.setState({isSaving: false})
          console.log(err)
      })
    }

  }


  handleUsers = (data)=> {
    this.setState({selectedUsers: data})
  }

  onTextChange = (e)=> {
    let text = e.target.value
    this.setState({text: text})
  }


  onDataSubmit = ()=> {
    let users = this.state.selectedUsers
    let text = this.state.text

    if(users.length > 0 && text.length > 10) {
      this.setState({isSaving: true})
      let conf = confirm("Are you sure ?")
      if(conf) {
        axios.post(
          `${BACKEND_URL}/v1/explore/addNotification`, {
              users: users,
              text: text
          }, {
              headers: {
                  token: localStorage.getItem("token")
              }
          }
        ).then((res) => {
          this.getAllList()
          this.typeahead.getInstance().clear();
          this.setState({isSaving: false, text: ""})

        }).catch((err) => {
          this.setState({isSaving: false})
            console.log(err)
        })
      }
    } else {
      alert("Add a user or text must be greater thn 10 char!")
    }
  }




  render() {
    const { notificationsList } = this.state;
    return (
      <div>
        <div className="col-md-12 topbar">
            <Navbar />
        </div>

        <main role="main" className="p-5">
          <div className="my-3 p-3 bg-white rounded shadow-sm">
            <h6 className="border-bottom border-gray pb-2 mb-0">BIS Workspace - Send Notifications</h6>
            <div className="card">
              <div className="card-body">

               <label className="form-label">Select single or multiple users</label>
               <AsyncTypeahead
                  id="user-options"
                  multiple
                  ref={(typeahead) => this.typeahead = typeahead}
                  isLoading={this.state.isLoading}
                  labelKey="name"
                  minLength={2}
                  onSearch={(query) => {
                    this.setState({isLoading: true});
                    fetch(`${BACKEND_URL}/v1/explore/searchUsers?name=${query}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'token': localStorage.getItem("token")
                          }
                      })
                      .then(resp => resp.json())
                      .then(json => this.setState({
                        isLoading: false,
                        options: json.data.map((i) => ({
                          avatar_url: i.user_image ? `${json.base}${i.user_image}` : 'https://insightmonk.com/assets/images/avatars/avatar-2.png',
                          id: i.id,
                          name: `${i.first_name} ${i.last_name} - ${i.email}`,
                        }))
                      }));
                  }}
                  onChange={this.handleUsers}
                  options={this.state.options}
                  placeholder="Search for insightmonk user..."
                  renderMenuItemChildren={(option, props) => (
                    <div>
                      <img
                        alt={option.name}
                        src={option.avatar_url}
                        style={{
                          height: '24px',
                          marginRight: '10px',
                          width: '24px',
                        }}
                      />
                      <span>{option.name}</span>
                    </div>
                  )}
                />

                <label className="form-label">Add a notification text</label>
                <Form.Control value={this.state.text} onChange={this.onTextChange} placeholder="Enter a text here..." as="textarea" rows="3" />

                <Button onClick={this.onDataSubmit} disabled={this.state.isSaving} variant="primary">{this.state.isSaving ? 'Saving...' : 'Submit'}</Button>
              </div>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Users</th>
                    <th>Notification</th>
                    <th>Added By</th>
                    <th style={{width: 150}}>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {notificationsList && notificationsList.map((o, index)=>
                    <tr key={index}>
                      <td>{o.id}</td>
                      <td>
                         <ListGroup>
                          { o.users && o.users.map((oo, ind)=>
                            <ListGroup.Item key={ind}><img src={oo.avatar_url} style={{width: 30, height: 30}} /> {oo.name}</ListGroup.Item>
                          )}
                        </ListGroup>

                      </td>
                      <td>{o.text}</td>
                      <td>{o.added_by}</td>
                      <td>{Moment(o.added_on).fromNow()}</td>
                      <td><button className="btn btn-danger btn-sm" onClick={()=> this.handleDelete(o._id)}>Delete</button></td>
                    </tr>
                  )}
                  { notificationsList && notificationsList.length == 0 &&
                    <tr><td colSpan="6">No Notifications Found</td></tr>
                  }
                </tbody>
              </Table>



            </div>
          </div>
        </main>
      </div>
    );
  }
}

function mapStateToProps(state){
    return { }
}

export default withRouter(connect(
  mapStateToProps
)(Notifications))




// WEBPACK FOOTER //
// ./src/components/Insights/Notifications.js